import React, {
    useEffect,
    useState
} from "react";

import useApi from "../../CustomHooks/useApi";

import {
    bankTransfersAPI
} from "../../../api/apiClient";

import Loading from "../../../Loading";

import "../../../css/Views/BankMonthVerificationView.css";

import {
    FontAwesomeIcon
} from "@fortawesome/react-fontawesome";

import {
    faCheckCircle,
    faExclamationTriangle,
    faUpload,
    faFileExcel,
    faSpinner,
    faChevronLeft,
    faChevronRight
} from "@fortawesome/free-solid-svg-icons";


const monthNames = [
    "Styczeń",
    "Luty",
    "Marzec",
    "Kwiecień",
    "Maj",
    "Czerwiec",
    "Lipiec",
    "Sierpień",
    "Wrzesień",
    "Październik",
    "Listopad",
    "Grudzień"
];


const BankMonthVerificationView = () => {
    const {
        callApi,
        isLoading,
        
    } = useApi();


    const now =
        new Date();


    const [
        year,
        setYear
    ] = useState(
        now.getFullYear()
    );


    const [
        month,
        setMonth
    ] = useState(
        now.getMonth() + 1
    );


    const [
        importResult,
        setImportResult
    ] = useState(null);


    const [
        verification,
        setVerification
    ] = useState(null);


    const [
        selectedFile,
        setSelectedFile
    ] = useState(null);


    const [
        isExportingOperations,
        setIsExportingOperations
    ] = useState(false);


    const fetchVerification = () => {
        callApi(
            () =>
                bankTransfersAPI.getMonthVerification(
                    year,
                    month
                ),
            (data) => {
                setVerification(
                    data
                );
            }
        );
    };


    useEffect(() => {
        fetchVerification();
    }, [
        year,
        month
    ]);


    const handlePreviousMonth = () => {
        setImportResult(null);

        if (month === 1) {
            setMonth(12);

            setYear(
                (current) =>
                    current - 1
            );

            return;
        }

        setMonth(
            (current) =>
                current - 1
        );
    };


    const handleNextMonth = () => {
        setImportResult(null);

        if (month === 12) {
            setMonth(1);

            setYear(
                (current) =>
                    current + 1
            );

            return;
        }

        setMonth(
            (current) =>
                current + 1
        );
    };


    const handleMonthChange = (
        event
    ) => {
        setImportResult(null);

        setMonth(
            Number(
                event.target.value
            )
        );
    };


    const handleYearChange = (
        event
    ) => {
        setImportResult(null);

        setYear(
            Number(
                event.target.value
            )
        );
    };


    const handleImport = () => {
        if (!selectedFile) {
            return;
        }

        callApi(
            () =>
                bankTransfersAPI.importMonthStatement(
                    selectedFile,
                    year,
                    month
                ),
            (data) => {
                setImportResult(
                    data
                );

                setSelectedFile(
                    null
                );

                fetchVerification();
            }
        );
    };


    const handleExportOperations =
        async () => {
            if (
                isExportingOperations
            ) {
                return;
            }

            setIsExportingOperations(
                true
            );

            try {
                const response =
                    await bankTransfersAPI
                        .exportOperationsList(
                            year,
                            month
                        );

                const blob =
                    new Blob(
                        [
                            response.data
                        ],
                        {
                            type:
                                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        }
                    );

                const url =
                    window.URL
                        .createObjectURL(
                            blob
                        );

                const link =
                    document
                        .createElement(
                            "a"
                        );

                link.href =
                    url;

                link.download =
                    `PLN_lista_operacji_${year}_${String(
                        month
                    ).padStart(
                        2,
                        "0"
                    )}.xlsx`;

                document.body
                    .appendChild(
                        link
                    );

                link.click();

                link.remove();

                window.URL
                    .revokeObjectURL(
                        url
                    );
            } catch (
                error
            ) {
                console.error(
                    "Błąd pobierania listy operacji:",
                    error
                );
            } finally {
                setIsExportingOperations(
                    false
                );
            }
        };


    const formatCurrency = (
        value
    ) =>
        new Intl.NumberFormat(
            "pl-PL",
            {
                style:
                    "currency",
                currency:
                    "PLN"
            }
        ).format(
            value ?? 0
        );


    const isVerified =
        verification &&
        verification.missingCount === 0 &&
        verification.transfersCount ===
            verification.verifiedCount;


    return (
        <div className="bank-month-verification">

            <div className="bank-month-verification-toolbar">

                <div
                    className="bank-month-navigation-button"
                    onClick={
                        handlePreviousMonth
                    }
                    title="Poprzedni miesiąc"
                >
                    <FontAwesomeIcon
                        icon={
                            faChevronLeft
                        }
                    />
                </div>


                <div className="bank-month-field">
                    <select
                        value={month}
                        onChange={
                            handleMonthChange
                        }
                    >
                        {monthNames.map(
                            (
                                name,
                                index
                            ) => (
                                <option
                                    key={
                                        name
                                    }
                                    value={
                                        index +
                                        1
                                    }
                                >
                                    {
                                        name
                                    }
                                </option>
                            )
                        )}
                    </select>

                </div>


                <div className="bank-month-field bank-month-year-field">

                    <input
                        type="number"
                        value={year}
                        min="2000"
                        max="2100"
                        onChange={
                            handleYearChange
                        }
                    />

                </div>


                <div
                    className="bank-month-navigation-button"
                    onClick={
                        handleNextMonth
                    }
                    title="Następny miesiąc"
                >
                    <FontAwesomeIcon
                        icon={
                            faChevronRight
                        }
                    />
                </div>

            </div>


            {isLoading && (
                <Loading
                    text="Sprawdzanie wyciągu..."
                />
            )}


            


            {!isLoading &&
                verification && (
                    <>

                        <div
                            className={`bank-verification-status ${
                                isVerified
                                    ? "is-success"
                                    : "is-warning"
                            }`}
                        >

                            <div className="bank-verification-status-main">

                                <div className="bank-verification-status-title">

                                    <FontAwesomeIcon
                                        icon={
                                            isVerified
                                                ? faCheckCircle
                                                : faExclamationTriangle
                                        }
                                    />

                                    <strong>
                                        {isVerified
                                            ? "Miesiąc zweryfikowany"
                                            : "Weryfikacja niepełna"}
                                    </strong>

                                </div>


                                <span className="bank-verification-status-description">
                                    {
                                        verification.verifiedCount
                                    }{" "}
                                    z{" "}
                                    {
                                        verification.transfersCount
                                    }{" "}
                                    przelewów w systemie potwierdzonych wyciągiem z banku
                                </span>

                            </div>


                            <button
                                type="button"
                                className="bank-verification-export-button"
                                onClick={
                                    handleExportOperations
                                }
                                disabled={
                                    !isVerified ||
                                    isExportingOperations
                                }
                            >
                                <FontAwesomeIcon
                                    icon={
                                        isExportingOperations
                                            ? faSpinner
                                            : faFileExcel
                                    }
                                    spin={
                                        isExportingOperations
                                    }
                                />

                                {isExportingOperations
                                    ? "Generowanie..."
                                    : "Lista operacji XLSX"}
                            </button>

                        </div>


                        <div className="bank-verification-summary">

                            <div className="bank-verification-summary-row header">
                                <span></span>
                                <span>
                                    System
                                </span>
                                <span>
                                    Wyciąg
                                </span>
                                <span>
                                    Różnica
                                </span>
                            </div>


                            <div className="bank-verification-summary-row">

                                <strong>
                                    Wpływy
                                </strong>

                                <span>
                                    {formatCurrency(
                                        verification.totalIncome
                                    )}
                                </span>

                                <span>
                                    {formatCurrency(
                                        verification.verifiedIncome
                                    )}
                                </span>

                                <span>
                                    {formatCurrency(
                                        verification.totalIncome -
                                            verification.verifiedIncome
                                    )}
                                </span>

                            </div>


                            <div className="bank-verification-summary-row">

                                <strong>
                                    Wydatki
                                </strong>

                                <span>
                                    {formatCurrency(
                                        verification.totalExpenses
                                    )}
                                </span>

                                <span>
                                    {formatCurrency(
                                        verification.verifiedExpenses
                                    )}
                                </span>

                                <span>
                                    {formatCurrency(
                                        verification.totalExpenses -
                                            verification.verifiedExpenses
                                    )}
                                </span>

                            </div>

                        </div>


                        <div className="bank-statement-import">

                            <div>

                                <strong>
                                    Wczytaj wyciąg bankowy
                                </strong>

                                <p>
                                    Wczytanie wyciągu uzupełni brakujące dane dla operacji z wybranego miesiąca.
                                </p>

                            </div>


                            <div className="bank-statement-import-actions">

                                <input
                                    type="file"
                                    accept=".csv"
                                    onChange={(e) =>
                                        setSelectedFile(
                                            e.target
                                                .files?.[0] ??
                                                null
                                        )
                                    }
                                />

                                <button
                                    type="button"
                                    onClick={
                                        handleImport
                                    }
                                    disabled={
                                        !selectedFile
                                    }
                                >
                                    <FontAwesomeIcon
                                        icon={
                                            faUpload
                                        }
                                    />

                                    Wczytaj
                                </button>

                            </div>

                        </div>


                        {verification
                            ?.missingTransfers
                            ?.length >
                            0 && (
                            <div className="bank-month-difference-section">

                                <h4>
                                    Brakuje w wyciągu

                                    <span>
                                        {
                                            verification
                                                .missingTransfers
                                                .length
                                        }
                                    </span>
                                </h4>


                                <div className="bank-month-difference-table-wrapper">

                                    <table className="bank-month-difference-table">

                                        <thead>
                                            <tr>
                                                <th>
                                                    Data
                                                </th>
                                                <th>
                                                    Kwota
                                                </th>
                                                <th>
                                                    Tytuł
                                                </th>
                                                <th>
                                                    Od/do kogo
                                                </th>
                                            </tr>
                                        </thead>


                                        <tbody>
                                            {verification
                                                .missingTransfers
                                                .map(
                                                    (
                                                        row
                                                    ) => (
                                                        <tr
                                                            key={
                                                                row.bankTransferGuid
                                                            }
                                                        >

                                                            <td>
                                                                {new Date(
                                                                    row.transferDate
                                                                ).toLocaleDateString(
                                                                    "pl-PL"
                                                                )}
                                                            </td>

                                                            <td
                                                                className={
                                                                    row.amount >=
                                                                    0
                                                                        ? "bank-month-positive"
                                                                        : "bank-month-negative"
                                                                }
                                                            >
                                                                {
                                                                    row.amount.toFixed(
                                                                        2
                                                                    )
                                                                }{" "}
                                                                zł
                                                            </td>

                                                            <td>
                                                                {
                                                                    row.title ||
                                                                    "—"
                                                                }
                                                            </td>

                                                            <td>
                                                                {
                                                                    row.senderName ||
                                                                    "—"
                                                                }
                                                            </td>

                                                        </tr>
                                                    )
                                                )}
                                        </tbody>

                                    </table>

                                </div>

                            </div>
                        )}


                        {importResult
                            ?.unmatchedFromStatement
                            ?.length >
                            0 && (
                            <div className="bank-month-difference-section">

                                <h4>
                                    Z wyciągu, ale nie znaleziono w systemie

                                    <span>
                                        {
                                            importResult
                                                .unmatchedFromStatement
                                                .length
                                        }
                                    </span>
                                </h4>


                                <div className="bank-month-difference-table-wrapper">

                                    <table className="bank-month-difference-table">

                                        <thead>
                                            <tr>
                                                <th>
                                                    Data
                                                </th>
                                                <th>
                                                    Kwota
                                                </th>
                                                <th>
                                                    Tytuł
                                                </th>
                                                <th>
                                                    Kontrahent
                                                </th>
                                                <th>
                                                    Powód
                                                </th>
                                            </tr>
                                        </thead>


                                        <tbody>
                                            {importResult
                                                .unmatchedFromStatement
                                                .map(
                                                    (
                                                        row,
                                                        index
                                                    ) => (
                                                        <tr
                                                            key={
                                                                index
                                                            }
                                                        >

                                                            <td>
                                                                {new Date(
                                                                    row.bookingDate
                                                                ).toLocaleDateString(
                                                                    "pl-PL"
                                                                )}
                                                            </td>

                                                            <td
                                                                className={
                                                                    row.amount >=
                                                                    0
                                                                        ? "bank-month-positive"
                                                                        : "bank-month-negative"
                                                                }
                                                            >
                                                                {
                                                                    row.amount.toFixed(
                                                                        2
                                                                    )
                                                                }{" "}
                                                                zł
                                                            </td>

                                                            <td>
                                                                {
                                                                    row.title ||
                                                                    "—"
                                                                }
                                                            </td>

                                                            <td>
                                                                {
                                                                    row.counterpartyName ||
                                                                    "—"
                                                                }
                                                            </td>

                                                            <td>
                                                                {
                                                                    row.comment ||
                                                                    "—"
                                                                }
                                                            </td>

                                                        </tr>
                                                    )
                                                )}
                                        </tbody>

                                    </table>

                                </div>

                            </div>
                        )}

                    </>
                )}

        </div>
    );
};


export default BankMonthVerificationView;